var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-history-entry__field-content"},_vm._l((_vm.allItems),function(item){return _c('div',{key:item.id,staticClass:"row-history-field-select-option__diff",class:{
      'row-history-field-select-option__diff--removed':
        _vm.removedItems.includes(item),
      'row-history-field-select-option__diff--added':
        _vm.addedItems.includes(item),
    }},[_c('div',{staticClass:"row-history-field-select-option__diff-inner",class:'background-color--' + _vm.selectOptionColor(item)},[_vm._v("\n      "+_vm._s(_vm.selectOptionValue(item))+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }